module.exports = __webpack_public_path__ + "static/img/top_banner.0847706.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/hmStyle/top_banner.png
// module id = YfPJ
// module chunks = 34